window.portalModule.factory 'ProceduresService', ($rootScope, $log, Restangular, AuthService, CacheFactory) ->
  $log = $log.getInstance('ProceduresService')

  # create a cache
  proceduresCache = CacheFactory('proceduresCache', {
    deleteOnExpire: 'aggressive',
    cacheFlushInterval: 1800000, # this cache will check for expired items 30 minutes
    storageMode: 'memory'
  })

  restAngular = Restangular.withConfig (Configurer) ->
    # configure the Restangular object here
    Configurer.setBaseUrl(AuthService.getConfigData().CLINICAL_ENDPOINT_URL)
    Configurer.setDefaultHttpFields({cache: proceduresCache})

  _proceduresService = restAngular.all("")

  findAll: ->
    return _proceduresService.customGET('procedures', {patient_practice_guid: $rootScope.DS.getCurrentPatientPracticeGuid()})